import { IAction } from 'src/typings';
import { ActionTypes } from 'src/store/locale/actions';
import { ILocale } from 'src/typings/locale';

export interface ILocaleReducer {
  locale: string[];
  groupSeparator: string;
  decimalSeparator: string;
}

export const initialState: ILocale = {
  locale: ['uk-UA'],
  groupSeparator: ' ',
  decimalSeparator: ',',
};

export const localReducer = (
  state = initialState,
  { type, payload }: IAction,
): ILocale => {
  switch (type) {
    case ActionTypes.SET_LOCALE: {
      return {
        ...state,
        ...payload,
      };
    }
    default:
      return state;
  }
};
